import * as React from "react";
const SvgFiRrDiceD12 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dice-d12_svg__a)">
      <path
        fill="#062147"
        d="m23.287 7.535-1.915-3.192a5 5 0 0 0-1.715-1.715L16.465.713A5 5 0 0 0 13.892 0h-3.784a5 5 0 0 0-2.573.713L4.343 2.628a5 5 0 0 0-1.715 1.715L.713 7.535A5 5 0 0 0 0 10.108v3.784a5 5 0 0 0 .713 2.573l1.915 3.192a5 5 0 0 0 1.715 1.715l3.192 1.915a5 5 0 0 0 2.573.713h3.784a5 5 0 0 0 2.573-.713l3.192-1.915a5 5 0 0 0 1.715-1.715l1.915-3.192A5 5 0 0 0 24 13.892v-3.784a5 5 0 0 0-.713-2.573m-1.715 1.029q.105.176.186.364l-4.02 4.823L13 11.382v-4.6l6.511-1.629q.078.107.146.22zM8.564 2.428A3 3 0 0 1 10.108 2h3.784a3 3 0 0 1 1.544.428l1.98 1.188L12 4.97 6.584 3.616zM4.343 5.372a3 3 0 0 1 .146-.22L11 6.78v4.6l-4.738 2.371-4.02-4.823q.081-.188.186-.364zm0 13.256-1.915-3.192A3 3 0 0 1 2 13.892v-2.129l3.123 3.748 1.934 5.157-1.685-1.011a3 3 0 0 1-1.029-1.029m5.339 3.341-2.429-6.477L12 13.118l4.748 2.374-2.43 6.477c-.141.02-4.495.02-4.636 0m11.89-6.533-1.915 3.192a3 3 0 0 1-1.029 1.029l-1.685 1.011 1.934-5.157L22 11.763v2.129a3 3 0 0 1-.428 1.544"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dice-d12_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiceD12;
